export default "__VITE_ASSET__BqqiJKuw__"